export const MONTHLY_PRICING_RANGE_COLUMNS_WITH_SEGMENT = [
  'requestingPlatformCode',
  'segmentDescription',
  'minimumDays',
  'maximumDays',
  'minimumRate',
  'maximumRate',
];

export const MONTHLY_PRICING_RANGE_COLUMNS_WITH_CURRENCY = [
  'requestingPlatformCode',
  'currencyIsoCode',
  'minimumDays',
  'maximumDays',
  'minimumRate',
  'maximumRate',
];

export const DEFAULT_PRICING_RANGE_COLUMNS_WITHOUT_CURRENCY = [
  'requestingPlatformCode',
  'minimumUfAmount',
  'maximumUfAmount',
  'minimumDays',
  'maximumDays',
  'maximumRate',
];

export const DEFAULT_PRICING_RANGE_COLUMNS_WITH_CURRENCY = [
  'requestingPlatformCode',
  'currencyIsoCode',
  'minimumUfAmount',
  'maximumUfAmount',
  'minimumDays',
  'maximumDays',
  'maximumRate',
];
